<div class="flex h-full w-[400px] flex-col space-y-4 text-sm">
  <div class="sticky top-0 z-10 flex flex-col space-y-4 bg-white pt-[5px]">
    <aux-input
      placeholder="Search"
      icon="Search"
      iconPosition="left"
      hotKey="/"
      (input)="onSearch($event)"
    />
    <div
      class="flex h-[40px] items-center justify-between space-x-2 border-b border-aux-gray-dark pb-2"
    >
      <aux-checkbox
        [checked]="isAllColumnsSelected()"
        [indeterminate]="isAllColumnsIndeterminate()"
        (customChange)="onSelectAll($event)"
        [id]="'column-chooser-select-all'"
      >
        <span class="ml-[3px]">{{ isAllColumnsSelected() ? 'Deselect All' : 'Select All' }}</span>
      </aux-checkbox>

      @if (chooser() && chooser()!.countPinnedColumns() > 0) {
        <aux-button
          variant="tertiary"
          icon="Pinned"
          [iconSize]="16"
          classList="text-[12px] pl-[7px]"
          label="Unpin All"
          svgAttributes="flex-shrink-0 !mr-0"
          (click)="onUnpinAll()"
        />
      }
    </div>
  </div>

  <div class="flex-grow overflow-auto">
    @if (columns()?.columns?.length) {
      <aux-column-chooser-items
        [columns]="columns()!.columns"
        [searchTerm]="searchTerm()"
        [reorder]="!!ref.data?.reorder"
        [showPinIcons]="!!ref.data?.showPinIcons"
        #chooser
      />
    }
    @if (chooser()?.getFilteredColumns()?.length === 0) {
      <div class="flex h-full items-center justify-center">
        <aux-column-chooser-no-items />
      </div>
    }
  </div>
</div>
